import { z } from 'zod'

export const openpanelConfigSchema = z.object({
  clientId: z.string().min(1, 'Client ID is required').max(200),
  trackScreenViews: z.boolean().default(true),
  trackOutgoingLinks: z.boolean().default(true),
})

export type OpenpanelConfig = z.infer<typeof openpanelConfigSchema>

export const googleAnalyticsConfigSchema = z.object({
  measurementId: z
    .string()
    .min(1, 'Measurement ID is required')
    .regex(/^G-[A-Z0-9]+$/, 'Must be a valid GA4 Measurement ID (e.g. G-XXXXXXXXXX)'),
})

export type GoogleAnalyticsConfig = z.infer<typeof googleAnalyticsConfigSchema>
